/* unplugin-vue-components disabled */import script from "./batch-maintain-dialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./batch-maintain-dialog.vue?vue&type=script&lang=ts&setup=true"

import "./batch-maintain-dialog.vue?vue&type=style&index=0&id=c531eb6a&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c531eb6a"]])

export default __exports__